import NoDataBanner from "components/common/NoDataBanner";
import Scroller from "components/common/Scroller/InfiniteScroller";
import Typography from "components/common/Typography";
import PlanBar from "components/common/plans/PlanBar";
import ActionCardDialogsContext from "components/features/ActionCard/Context";
import { useTranslate } from "hooks/useTranslate";
import React, { useContext, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import {
  DEFAULT_CORP_INNCODE,
  PAGE_SIZE,
  PlanAssigmentLimit,
  PlanSelectionLimit,
  allPlansType
} from "utils/CommonConstants";
import BubbleToggle from "../BubbleToggle";
import {
  fetchPlansAsync,
  fetchPropertyInfoAsync,
  fetchTemplatePlansAsync,
  setIsErrorWhenLimitExceed,
  setIsErrorWhenPlanSelectionExceed
} from "../PlanAssignment.slice";
import SelectedList from "../SelectedList";
import Filters from "./Filters";
import "./index.scss";

const PlanSelection = (props: any) => {
  const dispatch = useAppDispatch();
  const translate = useTranslate();
  const { setPayloadData, plans } = props;
  const { inncodes, targetClass, showToggle = true } = props;

  const { setIsOpenPlanDetaiLDialog } = useContext(ActionCardDialogsContext);

  const {
    planSelection: {
      totalList,
      list,
      filters: { searchText, functionalAreas, brand, region, planType }
    },
    payloadData: { users }
  } = useAppSelector((state) => state.PlanAssignment);

  const [pageNo, setPageNo] = useState(1);
  const [checkedList, setCheckedList] = useState<any>(plans);

  const getPlansAPIPayload = (page?: any) => {
    if (planType === translate("common.templatePlans")) {
      return {
        functionalArea: functionalAreas.join(","),
        pagination: {
          page: (page ?? pageNo) - 1,
          size: PAGE_SIZE
        },
        searchText: searchText,
        hasCardMandatory: true,
        planType: "TEMPLATE_PLAN",
        searchedPropertyText: ""
      };
    }
    return {
      filter: {
        innCode: inncodes || DEFAULT_CORP_INNCODE,
        functionalAreaIds: functionalAreas,
        brandCodes: brand,
        regions: region
      },
      pagination: {
        page: page ?? pageNo,
        size: PAGE_SIZE
      },
      searchText: searchText,
      planType: [allPlansType]
    };
  };

  useEffect(() => {
    if (props?.scListId && inncodes === DEFAULT_CORP_INNCODE)
      dispatch(fetchPropertyInfoAsync({ inncodes: props?.users?.map((item: any) => item?.innCode) }));
  }, []);

  useEffect(() => {
    setPageNo(1);
    apiCall(getPlansAPIPayload(1));
  }, [searchText, functionalAreas, brand, region, planType]);

  useEffect(() => {
    if (pageNo > 1) apiCall(getPlansAPIPayload());
  }, [pageNo]);

  const apiCall = (payload: any) => {
    if (planType === translate("common.templatePlans")) {
      dispatch(fetchTemplatePlansAsync(payload));
    } else {
      dispatch(fetchPlansAsync(payload));
    }
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>, plan: any) => {
    let arr = [...checkedList];
    if (event?.target?.checked) {
      if (checkedList.findIndex((element: any) => element?.id === plan?.id) < 0) {
        arr.push(plan);
      }
    } else {
      arr = arr.filter((item: any) => item?.id !== plan?.id);
    }
    setCheckedList(arr);
    dispatch(setPayloadData({ plans: arr }));
  };

  const fetchMore = () => setPageNo(pageNo + 1);
  const handleState = () => setIsOpenPlanDetaiLDialog(true);

  useEffect(() => {
    const planLength = plans?.length || 1;
    let userLength = 1;
    if (users.length) {
      userLength = users.length;
    }
    if (users?.hltId?.length) {
      userLength = users?.hltId?.length;
    }
    const isError = userLength * planLength > PlanAssigmentLimit;
    const planSelection = checkedList.length > PlanSelectionLimit;
    dispatch(setIsErrorWhenLimitExceed(isError));
    dispatch(setIsErrorWhenPlanSelectionExceed(planSelection));
  }, [checkedList]);

  return (
    <>
      <div className="plan_selection">
        <div className="plan_selection-heading">
          <Typography variant="h5" color={tokens.Text.General.PrimaryHeadline}>
            Select one or more Plans to assign
          </Typography>
          {showToggle && <BubbleToggle />}
        </div>
        <div>
          <Filters
            setCheckedList={setCheckedList}
            shouldHideTargetingFilters={
              (props?.scListId && inncodes !== DEFAULT_CORP_INNCODE) || props?.shouldHideTargetingFilters
            }
          />
          {list?.length > 0 ? (
            <div className="plan_selection-list">
              <SelectedList checkedList={checkedList} setCheckedList={handleCheckboxChange} type={"plans"} />
              <Scroller
                scrollableTarget={targetClass ?? "right-wrapper-container"}
                dataLength={list?.length}
                loadMore={fetchMore}
                totalList={totalList}
                label="Plans"
              >
                {list?.map((plan: any) => {
                  return (
                    <PlanBar
                      key={plan?.id}
                      plan={plan}
                      checkedList={checkedList}
                      handleCheckboxChange={(e, plan) => handleCheckboxChange(e, plan)}
                      handleState={handleState}
                      inncode={inncodes}
                    />
                  );
                })}
              </Scroller>
            </div>
          ) : (
            <>
              <NoDataBanner noDataMessage={"No Plans found"} />
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default PlanSelection;
